export const defaultJson = [
   {
     "stepId": "Basic Details",
     "stepName": "Application Form",
     "showStepName": false,
     "stepVisible": true,
     "stepPosition": 1,
     "stepType": "form",
     "sections": [
       {
         "sectionName": "Candidate Information",
         "apiKeyId": "applicant",
         "subSectionName": "",
         "sectionPosition": 1,
         "sectionVisible": true,
         "sectionType": "form",
         "fields": [
           {
             "fieldId": "applicant[salutation]",
             "required": true,
             "name": "applicant[salutation]",
             "label": "Salutation",
             "type": "select",
             "visible": true,
             "disabled": true,
             "validations": {
               "required": "This field is required",
               "pattern": {
                 "value": "",
                 "message": "Please Input a valid Salutation"
               }
             },
             "options": [
               {
                 "label": "Mr.",
                 "value": "Mr."
               },
               {
                 "label": "Mrs.",
                 "value": "Mrs."
               },
               {
                 "label": "Ms.",
                 "value": "Ms."
               }
             ]
           },
           {
             "fieldId": "applicant[combineFirstLast]",
             "required": true,
             "name": "applicant[combineFirstLast]",
             "label": "Full Name",
             "type": "input",
             "disabled": true,
             "validations": {
               "required": "This field is required",
               "pattern": {
                 "value": "",
                 "message": "Please Input a valid Name"
               }
             }
           },
           {
             "fieldId": "applicant[candidateId]",
             "required": true,
             "name": "applicant[candidateId]",
             "label": "Candidate ID",
             "type": "input",
             "disabled": true,
             "validations": {
               "required": "This field is required",
               "pattern": {
                 "value": "",
                 "message": "Please Input a valid  Name"
               }
             }
           },
           {
             "fieldId": "applicant[email]",
             "required": true,
             "name": "applicant[email]",
             "label": "Email",
             "disabled": true,
             "type": "input",
             "validationType": "email",
             "validations": {
               "required": "This field is required",
               "pattern": {
                 "value": "",
                 "message": "Please Input a valid Email"
               }
             }
           },
           {
             "fieldId": "applicant[phone]",
             "required": true,
             "name": "applicant[phone]",
             "label": "Mobile Number",
             "type": "phone",
             "apiKey": "applicant[phone]",
             "disabled": true,
             "validationType": "phone",
             "validations": {
               "required": "This field is required",
               "pattern": {
                 "value": "",
                 "message": "Please Input a valid Mobile Number"
               }
             }
           },
           {
             "fieldId": "applicant[trainingCentre]",
             "required": true,
             "name": "applicant[trainingCentre]",
             "label": "Training Centre",
             "type": "select",
             "disabled": false,
             "options": [
              {
                "label": "Gautam Budh University",
                "value": "Gautam Budh University"
              },
              {
                "label": "Babasaheb Bhimrao Ambedkar University",
                "value": "Babasaheb Bhimrao Ambedkar University"
              },
              {
                "label": "City Group of College",
                "value": "City Group of College"
              },
              {
                "label": "University of Lucknow",
                "value": "University of Lucknow"
              },
              {
                "label": "Subhash Chandra Bose Group Of Institution",
                "value": "Subhash Chandra Bose Group Of Institution"
              },
              {
                "label": "Bhavdiya Group of Institutions",
                "value": "Bhavdiya Group of Institutions"
              },
              {
                "label": "Deen Dayal Upadhyay Gorakhpur University",
                "value": "Deen Dayal Upadhyay Gorakhpur University"
              },
              {
                "label": "Madan Mohan Malviya University of Technology",
                "value": "Madan Mohan Malviya University of Technology"
              },
              {
                "label": "Sri Jayachamarajendra Polytechnic College, Banglore",
                "value": "Sri Jayachamarajendra Polytechnic College, Banglore"
              },
              {
                "label": "Government Sri Krishnarajendra Silver Jubilee Technological Institute",
                "value": "Government Sri Krishnarajendra Silver Jubilee Technological Institute"
              },
              {
                "label": "DIET Anakapalli",
                "value": "DIET Anakapalli"
              },
              {
                "label": "Vignan's Institute Of Information Technology",
                "value": "Vignan's Institute Of Information Technology"
              },
              {
                "label": "Visakha Womens College Viskhapatnam",
                "value": "Visakha Womens College Viskhapatnam"
              },
              {
                "label": "Prism Degree College Visakhhapatnam",
                "value": "Prism Degree College Visakhhapatnam"
              },
              {
                "label": 'Nrupathunga University, Bangalore',
                "value": 'Nrupathunga University, Bangalore',
              },
              {
                "label": 'DDUGKP - ITM Campus',
                "value": 'DDUGKP - ITM Campus',
              },
              {
                "label": 'University of Agricultural Sciences, Bangalore',
                "value": 'University of Agricultural Sciences, Bangalore',
              },
              {
                "label": "Amruta Institute of Engineering and Management Science, Bangalore",
                "value": "Amruta Institute of Engineering and Management Science, Bangalore"
              },
              {
                "label": "NIU Gautam Budh Nagar",
                "value": "NIU Gautam Budh Nagar"
              },
              {
                "label": "Govt RC College of Commerce and Management, Bangalore",
                "value": "Govt RC College of Commerce and Management, Bangalore"
              },
              {
                "label": "SKVT Government Degree college, Rajahmundry",
                "value": "SKVT Government Degree college, Rajahmundry"
              },
              {
                "label": "Maharani Cluster University, Bangalore",
                "value": "Maharani Cluster University, Bangalore"
              },
              {
                "label": "Government Polytechnic, Warangal",
                "value": "Government Polytechnic, Warangal"
              },
              {
                "label": "Jawaharlal Nehru Government Polytechnic, Ramanthapur, Hyderabad",
                "value": "Jawaharlal Nehru Government Polytechnic, Ramanthapur, Hyderabad"
              },
              {
                "label": "Shivani Degree College, Warangal",
                "value": "Shivani Degree College, Warangal"
              },
              {
                "label": "University College of Engineering and Technology for Women, Warangale",
                "value": "University College of Engineering and Technology for Women, Warangale"
              },
              {
                "label": "Brainware University, Kolkata",
                "value": "Brainware University, Kolkata"
              },
              {
                "label": "St. Joseph's College For Women (Autonomous), Vizag",
                "value": "St. Joseph's College For Women (Autonomous), Vizag"
              },
              {
                "label": "MS Ramaiah College of Arts Science & Commerce, Bangalore",
                "value": "MS Ramaiah College of Arts Science & Commerce, Bangalore"
              },
              {
                "label": "Nadimpalli Satyanarayana Raju Institute of Technology, Vizag",
                "value": "Nadimpalli Satyanarayana Raju Institute of Technology, Vizag"
              },
              {
                "label": "Sri Sai Vignan Bharti degree College For Women, Secundrabad",
                "value": "Sri Sai Vignan Bharti degree College For Women, Secundrabad"
              },
              {
                "label": "Dr. Ram Manohar Lohia Awadh University",
                "value": "Dr. Ram Manohar Lohia Awadh University"
              },
              {
                "label": "MVR Degree College, Visakhapatnam",
                "value": "MVR Degree College, Visakhapatnam"
              },
              {
                "label": "Chaitanya Degree College For Women, Visakhapatnam",
                "value": "Chaitanya Degree College For Women, Visakhapatnam"
              },
              {
                "label": "Engineering Institute For Junior Executives (E.I.J.E)",
                "value": "Engineering Institute For Junior Executives (E.I.J.E)"
              },
              {
                "label": "NSIC Hyderabad",
                "value": "NSIC Hyderabad"
              },
              {
                "label": "Kasturba Gandhi Degree & PG College For Women, Secunderabad",
                "value": "Kasturba Gandhi Degree & PG College For Women, Secunderabad"
              },
              {
                "label": "Baba Institute of Technology & Sciences, Visakhapatnam",
                "value": "Baba Institute of Technology & Sciences, Visakhapatnam"
              },
              {
                "label": "Women's Polytechnic, Kolkata",
                "value": "Women's Polytechnic, Kolkata"
              },
              {
                "label": "Jnan Chandra Ghosh Polytechnic, Kolkata",
                "value": "Jnan Chandra Ghosh Polytechnic, Kolkata"
              },
              {
                "label": "DDGKP - Government Girls Polytechnic, Gorakhpur",
                "value": "DDGKP - Government Girls Polytechnic, Gorakhpur"
              },
              {
                "label": "Khwaja Moinuddin Chishti Language University, Lucknow",
                "value": "Khwaja Moinuddin Chishti Language University, Lucknow"
              },
              {
                "label": "Govt. PG COLLEGE, NOIDA, GAUTAM BUDDHA NAGAR",
                "value": "Govt. PG COLLEGE, NOIDA, GAUTAM BUDDHA NAGAR"
              },
              {
                "label": "Acharyya Prafulla Chandra Ray Polytechnic, Kolkata",
                "value": "Acharyya Prafulla Chandra Ray Polytechnic, Kolkata"
              },
              {
                "label": "Lucknow University (Old Campus)",
                "value": "Lucknow University (Old Campus)"
              },
              {
                "label": "Dr. Ambedkar Institute of Technology for Divyangjan (A.I.T.D.), Kanpur",
                "value": "Dr. Ambedkar Institute of Technology for Divyangjan (A.I.T.D.), Kanpur"
              },
              {
                "label": "JNTUH University College of Engineering Nachupally (Kondagattu)",
                "value": "JNTUH University College of Engineering Nachupally (Kondagattu)"
              },
              {
                "label": "University College of Engineering Tindivanam",
                "value": "University College of Engineering Tindivanam"
              },
              {
                "label": "RRASE COLLEGE OF ENGINEERING",
                "value": "RRASE COLLEGE OF ENGINEERING"
              },
              {
                "label": "Dr MGR Educational and Research Institute (Deemed to be University)",
                "value": "Dr MGR Educational and Research Institute (Deemed to be University)"
              },
              {
                "label": "Sree Aman Arts & Science College",
                "value": "Sree Aman Arts & Science College"
              },
              {
                "label": "San International College Arts & Science",
                "value": "San International College Arts & Science"
              },
              {
                "label": "SNS college of Technology, Coimbatore",
                "value": "SNS college of Technology, Coimbatore"
              },
              {
                "label": "Mangayarkarasi College of Engineering, Madurai",
                "value": "Mangayarkarasi College of Engineering, Madurai"
              },
              {
                "label": "Manikam Ramaswami College, Madurai",
                "value": "Manikam Ramaswami College, Madurai"
              },
              {
                "label": "SNS College of Technology, Coimbatore, Tamil Nadu",
                "value": "SNS College of Technology, Coimbatore, Tamil Nadu"
              },
              {
                "label": "SA College of Arts and Science",
                "value": "SA College of Arts and Science"
              },
              {
                "label": "Government Arts and Science College, R K Nagar",
                "value": "Government Arts and Science College, R K Nagar"
              },
              {
                "label": "Government Arts and Science College, Nemmeli",
                "value": "Government Arts and Science College, Nemmeli"
              },
              {
                "label": "Sardar Raja College of Engineering Alangulam, Tamil Nadu",
                "value": "Sardar Raja College of Engineering Alangulam, Tamil Nadu"
              },
              {
                "label": "Grace College of Engineering, Tuticorin, Tamilnadu",
                "value": "Grace College of Engineering, Tuticorin, Tamilnadu"
              },
              {
                "label": "Anna University, Guindy, Chennai",
                "value": "Anna University, Guindy, Chennai"
              },
              {
                "label": "IARE, Hyderabad",
                "value": "IARE, Hyderabad"
              },
              {
                "label": "Mangayarkarasi college of engineering, Madurai",
                "value": "Mangayarkarasi college of engineering, Madurai"
              },
              {
                "label": "S.A. Engineering college",
                "value": "S.A. Engineering college"
              },
              {
                "label": "SRM Easwari Engineering College",
                "value": "SRM Easwari Engineering College"
              },
              {
                "label": "Global Institute of engineering and technology",
                "value": "Global Institute of engineering and technology"
              },
              {
                "label": "Little Flower Polytechnic College, Porur",
                "value": "Little Flower Polytechnic College, Porur"
              },
              {
                "label": "Queen Mary's College",
                "value": "Queen Mary's College"
              },
              {
                "label": "Government Arts College for Men",
                "value": "Government Arts College for Men"
              },
              {
                "label": "University of Madras",
                "value": "University of Madras"
              },
              {
                "label": "Sri Eshwar College of Engineering, Coimbatore",
                "value": "Sri Eshwar College of Engineering, Coimbatore"
              },
              {
                "label": "KPR Institute of Engineering and Technology",
                "value": "KPR Institute of Engineering and Technology"
              },
              {
                "label": "Government Polytechnic College, Sevvapet",
                "value": "Government Polytechnic College, Sevvapet"
              },
              {
                "label": "Sri Ramanas College of arts and science for Women, Chidambarapuram",
                "value": "Sri Ramanas College of arts and science for Women, Chidambarapuram"
              },
              {
                "label": "BHARATHI WOMEN'S COLLEGE",
                "value": "BHARATHI WOMEN'S COLLEGE"
              },
              {
                "label": "Quaid E Millath womens govt college",
                "value": "Quaid E Millath womens govt college"
              },
              {
                "label": "Mohamed Sathak A.J. College of Engineering",
                "value": "Mohamed Sathak A.J. College of Engineering"
              },
              {
                "label": "Rajalakshmi Engineering College",
                "value": "Rajalakshmi Engineering College"
              },
              {
                "label": "V.V.Vanniaperumal College for Women (VVV College)",
                "value": "V.V.Vanniaperumal College for Women (VVV College)"
              },
              {
                "label": "Chennai National Arts and Science College",
                "value": "Chennai National Arts and Science College"
              },
              {
                "label": "The MDT Hindu College, Pettai, Tirunelveli",
                "value": "The MDT Hindu College, Pettai, Tirunelveli"
              },
              {
                "label": "Arulmigu Kabaaleeswarar Arts - Science College",
                "value": "Arulmigu Kabaaleeswarar Arts - Science College"
              },
              {
                "label": "Thamirabharani Engineering College, Tirunelveli",
                "value": "Thamirabharani Engineering College, Tirunelveli"
              },
              {
                "label": "Bharath Institute of Higher Education and Research",
                "value": "Bharath Institute of Higher Education and Research"
              },
              {
                "label": "St. Xavier's, Palayamkottai",
                "value": "St. Xavier's, Palayamkottai"
              }
             ]
           },
           {
             "fieldId": "applicant[course]",
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Gautam Budh University",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Babasaheb Bhimrao Ambedkar University",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
               {
                 "label": "Big Data",
                 "value": "Big Data"
               },
               {
                 "label": "Coding & Programming",
                 "value": "Coding & Programming"
               },
               {
                 "label": "Artificial Intelligence",
                 "value": "Artificial Intelligence"
               },
               {
                 "label": "Internet Of Things",
                 "value": "Internet Of Things"
               }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "City Group of College",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
               {
                 "label": "Coding & Programming",
                 "value": "Coding & Programming"
               },
               {
                 "label": "Artificial Intelligence",
                 "value": "Artificial Intelligence"
               },
               {
                "label": "Big Data",
                "value": "Big Data"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "University of Lucknow",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Subhash Chandra Bose Group Of Institution",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Bhavdiya Group of Institutions",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Deen Dayal Upadhyay Gorakhpur University",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Madan Mohan Malviya University of Technology",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Sri Jayachamarajendra Polytechnic College, Banglore",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Government Sri Krishnarajendra Silver Jubilee Technological Institute",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "DIET Anakapalli",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
             ]
           },
           {
             "name": "applicant[course]",
             "label": "Course",
             "required": true,
             "type": "select",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[trainingCentre]",
                 "expectedValue": "Vignan's Institute Of Information Technology",
                 "type": "LEAF"
               }
             },
             "disabled": false,
             "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
             ]
           },
           {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Visakha Womens College Viskhapatnam",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Prism Degree College Visakhhapatnam",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Nrupathunga University, Bangalore",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "DDUGKP - ITM Campus",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Amruta Institute of Engineering and Management Science, Bangalore",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "NIU Gautam Budh Nagar",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Govt RC College of Commerce and Management, Bangalore",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "SKVT Government Degree college, Rajahmundry",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Maharani Cluster University, Bangalore",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Government Polytechnic, Warangal",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Jawaharlal Nehru Government Polytechnic, Ramanthapur, Hyderabad",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Shivani Degree College, Warangal",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "University College of Engineering and Technology for Women, Warangal",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Brainware University, Kolkata",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "St. Joseph's College For Women (Autonomous), Vizag",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "MS Ramaiah College of Arts Science & Commerce, Bangalore",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Nadimpalli Satyanarayana Raju Institute of Technology, Vizag",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Sri Sai Vignan Bharti degree College For Women, Secundrabad",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Dr. Ram Manohar Lohia Awadh University",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             },
             {
               "label": "Artificial Intelligence",
               "value": "Artificial Intelligence"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "MVR Degree College, Visakhapatnam",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Chaitanya Degree College For Women, Visakhapatnam",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Engineering Institute For Junior Executives (E.I.J.E)",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             },
             {
               "label": "Artificial Intelligence",
               "value": "Artificial Intelligence"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "NSIC Hyderabad",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Kasturba Gandhi Degree & PG College For Women, Secunderabad",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             },
             {
               "label": "Artificial Intelligence",
               "value": "Artificial Intelligence"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Baba Institute of Technology & Sciences, Visakhapatnam",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Artificial Intelligence",
               "value": "Artificial Intelligence"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Women's Polytechnic, Kolkata",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             },
             {
               "label": "Artificial Intelligence",
               "value": "Artificial Intelligence"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Jnan Chandra Ghosh Polytechnic, Kolkata",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
             {
               "label": "Coding & Programming",
               "value": "Coding & Programming"
             }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "DDGKP - Government Girls Polytechnic, Gorakhpur",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Khwaja Moinuddin Chishti Language University, Lucknow",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Govt. PG COLLEGE, NOIDA, GAUTAM BUDDHA NAGAR",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Acharyya Prafulla Chandra Ray Polytechnic, Kolkata",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Lucknow University (Old Campus)",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Dr. Ambedkar Institute of Technology for Divyangjan (A.I.T.D.), Kanpur",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "JNTUH University College of Engineering Nachupally (Kondagattu)",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "University College of Engineering Tindivanam",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "RRASE COLLEGE OF ENGINEERING",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Dr MGR Educational and Research Institute (Deemed to be University)",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Sree Aman Arts & Science College",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "San International College Arts & Science",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "SNS college of Technology, Coimbatore",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Mangayarkarasi College of Engineering, Madurai",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Manikam Ramaswami College, Madurai",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "SNS College of Technology, Coimbatore, Tamil Nadu",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "SA College of Arts and Science",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Government Arts and Science College, R K Nagar",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Government Arts and Science College, Nemmeli",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Sardar Raja College of Engineering Alangulam, Tamil Nadu",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Grace College of Engineering, Tuticorin, Tamilnadu",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Anna University, Guindy, Chennai",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "IARE, Hyderabad ",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Mangayarkarasi college of engineering, Madurai",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Big Data",
                "value": "Big Data"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "S.A. Engineering college",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "SRM Easwari Engineering College",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Global Institute of engineering and technology",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Little Flower Polytechnic College, Porur",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Queen Mary's College",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Big Data",
                "value": "Big Data"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Government Arts College for Men",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "University of Madras",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Sri Eshwar College of Engineering, Coimbatore",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "KPR Institute of Engineering and Technology",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Government Polytechnic College, Sevvapet",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Sri Ramanas College of arts and science for Women, Chidambarapuram",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "BHARATHI WOMEN'S COLLEGE",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Quaid E Millath womens govt college",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Mohamed Sathak A.J. College of Engineering",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              },
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Rajalakshmi Engineering College",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Internet Of Things",
                "value": "Internet Of Things"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "V.V.Vanniaperumal College for Women (VVV College)",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Coding & Programming",
                "value": "Coding & Programming"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Chennai National Arts and Science College",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "The MDT Hindu College, Pettai, Tirunelveli",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Arulmigu Kabaaleeswarar Arts - Science College",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Thamirabharani Engineering College, Tirunelveli",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              },
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "Bharath Institute of Higher Education and Research",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[trainingCentre]",
                "expectedValue": "St. Xavier's, Palayamkottai",
                "type": "LEAF"
              }
            },
            "disabled": false,
            "options": [
              {
                "label": "Big Data",
                "value": "Big Data"
              }
            ]
          },
           {
             "fieldId": "applicant[dateOfBirth]",
             "required": true,
             "name": "applicant[dateOfBirth]",
             "label": "Date of Birth",
             "type": "date",
             "maxDate": "-18",
             "minDate": "26",
             "validations": {
               "required": "This field is required"
             }
           },
           {
             "fieldId": "applicant[ageAsOnDate]",
             "required": true,
             "name": "applicant[ageAsOnDate]",
             "label": "Age",
             "type": "input",
             "disabled": true,
             "validations": {
               "required": "This field is required"
             }
           },
           {
             "fieldId": "application[proofOfIdentity]",
             "required": true,
             "name": "application[proofOfIdentity]",
             "label": "Proof Of Identity",
             "type": "select",
             "visible": true,
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "Aadhaar",
                 "value": "Aadhaar"
               },
               {
                 "label": "VoterID",
                 "value": "VoterID"
               },
               {
                 "label": "Driving License",
                 "value": "Driving License"
               }
             ]
           },
           {
             "name": "applicant[aadharNumber]",
             "label": "Aadhaar Number",
             "required": true,
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "application[proofOfIdentity]",
                 "expectedValue": "Aadhaar",
                 "type": "LEAF"
               }
             },
             "type": "input",
             "validationType": "number",
             "visible": true,
             "fieldId": "aadharNumber",
             "validations": {
               "required": {
                 "value": true,
                 "message": "Field is required"
               },
               "minLength": {
                 "value": 12,
                 "message": "Invalid Aadhaar number. Please enter a 12-digit Aadhaar number."
               },
               "maxLength": {
                 "value": 12,
                 "message": "Invalid Aadhaar number. Please enter a 12-digit Aadhaar number."
               },
               "pattern": {
                 "value": "",
                 "message": "Please input a correct value"
               }
             }
           },
           {
             "name": "applicant[votersId]",
             "label": "Voter ID",
             "required": true,
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "application[proofOfIdentity]",
                 "expectedValue": "VoterID",
                 "type": "LEAF"
               }
             },
             "type": "input",
             "validationType": "alphaNumeric",
             "visible": true,
             "fieldId": "voterId",
             "validations": {
               "required": {
                 "value": true,
                 "message": "Field is required"
               },
               "minLength": {
                 "value": 10,
                 "message": "Invalid Voter ID. Please enter the correct Voter ID details."
               },
               "maxLength": {
                 "value": 10,
                 "message": "Invalid Voter ID. Please enter the correct Voter ID details."
               },
               "pattern": {
                 "value": "",
                 "message": "Please input a correct value"
               }
             }
           },
           {
             "name": "applicant[drivingLicense]",
             "label": "Driving License",
             "required": true,
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "application[proofOfIdentity]",
                 "expectedValue": "Driving License",
                 "type": "LEAF"
               }
             },
             "type": "input",
             "validationType": "",
             "visible": true,
             "fieldId": "drivingLicense",
             "validations": {
               "required": {
                 "value": true,
                 "message": "Field is required"
               },
               "minLength": {
                 "value": 8,
                 "message": "Invalid Driving License. Please enter the correct Driving License details."
               },
               "maxLength": {
                 "value": 20,
                 "message": "Invalid Driving License. Please enter the correct Driving License details."
               },
               "pattern": {
                 "value": "",
                 "message": "Please input a correct value"
               }
             }
           },
           {
             "fieldId": "applicant[gender]",
             "required": true,
             "name": "applicant[gender]",
             "label": "Gender",
             "type": "radio",
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "Male",
                 "value": "Male"
               },
               {
                 "label": "Female",
                 "value": "Female"
               },
               {
                 "label": "Prefer not to say",
                 "value": "Prefer not to say"
               }
             ]
           },
           {
             "fieldId": "applicant[fatherName]",
             "required": true,
             "name": "applicant[fatherName]",
             "label": "Father's Name",
             "type": "input",
             "validationType": "alpha",
             "disabled": false,
             "validations": {
               "required": "This field is required",
               "minLength": {
                 "value": "2",
                 "message": "Please enter a valid name"
               },
               "maxLength": {
                 "value": "40",
                 "message": "This field can't be more than 40 characters"
               },
               "pattern": {
                 "value": "",
                 "message": "Please Input a valid Name"
               }
             }
           },
           {
             "fieldId": "applicant[motherName]",
             "required": true,
             "name": "applicant[motherName]",
             "label": "Mother's Name",
             "type": "input",
             "validationType": "alpha",
             "disabled": false,
             "validations": {
               "required": "This field is required",
               "minLength": {
                 "value": "2",
                 "message": "Please enter a valid name"
               },
               "maxLength": {
                 "value": "40",
                 "message": "This field can't be more than 40 characters"
               },
               "pattern": {
                 "value": "",
                 "message": "Please Input a valid Name"
               }
             }
           },
           {
             "fieldId": "applicant[category]",
             "required": true,
             "name": "applicant[category]",
             "label": "Category",
             "type": "select",
             "visible": true,
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "General",
                 "value": "General"
               },
               {
                 "label": "OBC",
                 "value": "OBC"
               },
               {
                 "label": "SC",
                 "value": "SC"
               },
               {
                 "label": "ST",
                 "value": "ST"
               },
               {
                 "label": "EWS",
                 "value": "EWS"
               }
             ]
           },
           {
             "fieldId": "applicant[highestQualification]",
             "required": true,
             "name": "applicant[highestQualification]",
             "label": "Highest Qualification",
             "type": "select",
             "disabled": false,
             "options": [
               {
                 "label": "12th",
                 "value": "12th"
               },
               {
                 "label": "Diploma",
                 "value": "Diploma"
               },
               {
                 "label": "UG",
                 "value": "UG"
               },
               {
                 "label": "PG",
                 "value": "PG"
               },
               {
                 "label": "Other",
                 "value": "Other"
               }
             ],
             "validations": {
               "required": "This field is required"
             }
           },
           {
             "name": "applicant[highestQualificationOthers]",
             "label": "Highest Qualification Other",
             "required": true,
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[highestQualification]",
                 "expectedValue": "Other",
                 "type": "LEAF"
               }
             },
             "type": "input",
             "validationType": "alpha",
             "visible": true,
             "fieldId": "highestQualificationOthers",
             "validations": {
               "required": {
                 "value": true,
                 "message": "Field is required"
               },
               "pattern": {
                 "value": "",
                 "message": "Please input a correct value"
               }
             }
           },
           {
             "fieldId": "applicant[presentStatus]",
             "required": true,
             "name": "applicant[presentStatus]",
             "label": "Highest Qualification Status",
             "type": "select",
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "Pursuing",
                 "value": "Pursuing"
               },
               {
                 "label": "Completed",
                 "value": "Completed"
               }
             ]
           },
           {
             "fieldId": "application[yearOfPassing]",
             "required": true,
             "name": "application[yearOfPassing]",
             "label": "Year Of Passing",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[presentStatus]",
                 "expectedValue": "Pursuing",
                 "type": "LEAF"
               }
             },
             "type": "select",
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "2025",
                 "value": "2025"
               },
               {
                 "label": "2024",
                 "value": "2024"
               },
               {
                 "label": "2025",
                 "value": "2025"
               },
               {
                 "label": "2026",
                 "value": "2026"
               },
               {
                 "label": "2027",
                 "value": "2027"
               },
               {
                 "label": "2028",
                 "value": "2028"
               },
               {
                 "label": "2029",
                 "value": "2029"
               },
               {
                 "label": "2030",
                 "value": "2030"
               }
             ]
           },
           {
             "name": "application[yearOfPassing]",
             "required": true,
             "label": "Year Of Passing",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "applicant[presentStatus]",
                 "expectedValue": "Completed",
                 "type": "LEAF"
               }
             },
             "type": "select",
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "2017",
                 "value": "2017"
               },
               {
                 "label": "2018",
                 "value": "2018"
               },
               {
                 "label": "2019",
                 "value": "2019"
               },
               {
                 "label": "2020",
                 "value": "2020"
               },
               {
                 "label": "2021",
                 "value": "2021"
               },
               {
                 "label": "2022",
                 "value": "2022"
               },
               {
                 "label": "2023",
                 "value": "2023"
               },
               {
                 "label": "2024",
                 "value": "2024"
               },
                {
                 "label": "2025",
                 "value": "2025"
               },
             ]
           }
         ]
       },
       {
        "sectionName": "Address Information",
        "apiKeyId": "applicant",
        "subSectionName": "",
        "sectionId": "Addresses",
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          // {
          //   "name": "addresses[0]",
          //   "type": "address",
          //   "options": [
          //     {
          //       "fieldId": "mailingCountry",
          //       "required": true,
          //       "name": "mailingCountry",
          //       "isPartOfCollection": true,
          //       "label": "Country",
          //       "type": "select",
          //       "validations": {
          //         "required": "This field is required"
          //       }
          //     }
          //   ]
          // },
          // {
          //   "name": "addresses[0]",
          //   "type": "address",
          //   "rule": {
          //     "effect": "HIDE",
          //     "condition": {
          //       "scope": "addresses[0][mailingCountry]",
          //       "expectedValue": "India",
          //       "type": "LEAF"
          //     }
          //   },
          //   "options": [
          //     {
          //       "fieldId": "mailingState",
          //       "required": true,
          //       "name": "mailingState",
          //       "label": "State",
          //       "type": "select",
          //       "validations": {
          //         "required": "This field is required"
          //       },
          //       "options": []
          //     },
          //     {
          //       "fieldId": "mailingDistrict",
          //       "required": true,
          //       "name": "mailingDistrict",
          //       "label": "City",
          //       "type": "select",
          //       "validations": {
          //         "required": "This field is required"
          //       },
          //       "options": []
          //     }
          //   ]
          // },
          // {
          //   "fieldId": "addresses[0][mailingPostalCode]",
          //   "required": true,
          //   "name": "addresses[0][mailingPostalCode]",
          //   "label": "PIN / PO BOX/ ZIP",
          //   "type": "input",
          //   "validationType": "number",
          //   "validations": {
          //     "required": "This field is required",
          //     "minLength": {
          //       "value": 6,
          //       "message": "Please enter a valid Pin code"
          //     },
          //     "maxLength": {
          //       "value": 6,
          //       "message": "Please enter a valid Pin code"
          //     },
          //     "pattern": {
          //       "value": "",
          //       "message": "Please enter a valid Pin code"
          //     }
          //   },
          //   "rule": {
          //     "effect": "HIDE",
          //     "condition": {
          //       "scope": "addresses[0][mailingCountry]",
          //       "expectedValue": "India",
          //       "type": "LEAF"
          //     }
          //   }
          // },
          {
            "name": "addresses[0]",
            "type": "pincode",
            // "rule": {
            //   "effect": "SHOW",
            //   "condition": {
            //     "scope": "addresses[0][mailingCountry]",
            //     "expectedValue": "India",
            //     "type": "LEAF"
            //   }
            // },
            "options": [
              {
                "fieldId": "mailingPostalCode",
                "name": "mailingPostalCode",
                "label": "PIN / PO BOX/ ZIP",
                "helperText": "If your city and state is not getting auto populated, Please use the nearest PIN / PO BOX/ ZIP",
                "required": true,
                "validationType": "number",
                "validations": {
                  "required": "This field is required",
                  "maxLength": {
                    "value": 6,
                    "message": "This field can't be more than 6 character"
                  },
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid Pin code"
                  }

                },
                "ui": {
                  "gridType": "halfRow"
                },
                "type": "input"
              },
              {
                "fieldId": "mailingState",
                "name": "mailingState",
                "label": "State",
                "validations": {
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid value"
                  },
                  "maxLength": {
                    "value": 80,
                    "message": "This field can't be more than 80 character"
                  }
                },
                "validationType": "alpha",
                "type": "input",
                "ui": {
                  "gridType": "halfRow"
                }
              },
              {
                "fieldId": "mailingDistrict",
                "name": "mailingDistrict",
                "label": "City",
                "validations": {
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid value"
                  },
                  "maxLength": {
                    "value": 80,
                    "message": "This field can't be more than 80 character"
                  }
                },
                "validationType": "alpha",
                "ui": {
                  "gridType": "halfRow"
                },
                "type": "input"
              }
            ]
          },
          {
            "fieldId": "addresses[0][mailingStreet]",
            "required": true,
            "name": "addresses[0][mailingStreet]",
            "label": "Address",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 250,
                "message": "This field cannot be more than 250 characters"
              },
              "minLength": {
                "value": 5,
                "message": "Please add valid address"
              }
            }
          }
        ]
       },
       {
         "sectionName": "Current Address",
         "apiKeyId": "applicant",
         "subSectionName": "",
         "sectionId": "Addresses",
         "showSectionName": false,
         "sectionPosition": 1,
         "sectionVisible": true,
         "sectionType": "form",
         "fields": [
           {
             "fieldId": "addresses[0][isPermanentAddressSame]",
             "required": true,
             "name": "addresses[0][isPermanentAddressSame]",
             "label": "Is your current address same as permanent address?",
             "type": "select",
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "Yes",
                 "value": "true"
               },
               {
                 "label": "No",
                 "value": "false"
               }
             ],
             "ui": {
               "gridType": "fullRow"
             }
           },
           {
             "name": "addresses[1]",
             "type": "address",
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "addresses[0][isPermanentAddressSame]",
                 "expectedValue": "false",
                 "type": "LEAF"
               },
               "unregister": true
             },
             "options": [
               {
                 "fieldId": "mailingCountry",
                 "required": true,
                 "name": "mailingCountry",
                 "isPartOfCollection": true,
                 "label": "Country",
                 "type": "select",
                 "validations": {
                   "required": "This field is required"
                 }
               },
               {
                 "fieldId": "mailingState",
                 "required": true,
                 "name": "mailingState",
                 "label": "State",
                 "type": "select",
                 "validations": {
                   "required": "This field is required"
                 },
                 "options": []
               },
               {
                 "fieldId": "mailingDistrict",
                 "required": true,
                 "name": "mailingDistrict",
                 "label": "City",
                 "type": "select",
                 "validations": {
                   "required": "This field is required"
                 },
                 "options": []
               }
             ]
           },
           {
             "fieldId": "addresses[1][mailingStreet]",
             "name": "addresses[1][mailingStreet]",
             "label": "Address",
             "type": "input",
             "required": true,
             "validationType": "alphaNumeric",
             "validations": {
               "required": "This field is required",
               "minLength": {
                 "value": 5,
                 "message": "Please enter a valid address"
               },
               "maxLength": {
                 "value": 120,
                 "message": "This field cannot be more than 120 characters"
               }
             },
             "ui": {
               "grid": {
                 "xs": 12,
                 "md": 6,
                 "lg": 6
               }
             },
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "addresses[0][isPermanentAddressSame]",
                 "expectedValue": "false",
                 "type": "LEAF"
               },
               "unregister": true
             }
           },
           {
             "name": "addresses[1]",
             "type": "address",
             "ui": {
               "grid": {
                 "xs": 12,
                 "md": 6,
                 "lg": 6
               }
             },
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "addresses[0][isPermanentAddressSame]",
                 "expectedValue": "false",
                 "type": "LEAF"
               },
               "unregister": true
             },
             "options": [
               {
                 "fieldId": "hed__MailingCountry__c",
                 "required": true,
                 "name": "hed__MailingCountry__c",
                 "label": "Country",
                 "type": "select",
                 "options": [],
                 "validations": {
                   "required": "This field is required"
                 }
               },
               {
                 "fieldId": "hed__MailingState__c",
                 "required": true,
                 "name": "hed__MailingState__c",
                 "label": "State",
                 "type": "select",
                 "validations": {
                   "required": "This field is required"
                 }
               },
               {
                 "fieldId": "hed__MailingCity__c",
                 "required": true,
                 "name": "hed__MailingCity__c",
                 "label": "City",
                 "type": "select",
                 "validations": {
                   "required": "This field is required"
                 },
                 "options": []
               }
             ]
           },
           {
             "fieldId": "addresses[1][mailingPostalCode]",
             "required": true,
             "name": "addresses[1][mailingPostalCode]",
             "label": "PIN / PO BOX/ ZIP",
             "type": "input",
             "validationType": "alphaNumeric",
             "validations": {
               "required": "This field is required",
               "minLength": {
                 "value": 6,
                 "message": "Please enter a valid Pin code"
               },
               "maxLength": {
                 "value": 6,
                 "message": "Please enter a valid Pin code"
               },
               "pattern": {
                 "value": "",
                 "message": "Please enter a valid Pin code"
               }
             },
             "ui": {
               "grid": {
                 "xs": 12,
                 "md": 6,
                 "lg": 6
               }
             },
             "rule": {
               "effect": "SHOW",
               "condition": {
                 "scope": "addresses[0][isPermanentAddressSame]",
                 "expectedValue": "false",
                 "type": "LEAF"
               },
               "unregister": true
             }
           }
         ]
       },
       {
         "sectionName": "Career Goal Section",
         "apiKeyId": "applicant",
         "subSectionName": "",
         "sectionPosition": 1,
         "sectionVisible": true,
         "sectionType": "form",
         "fields": [
           {
             "fieldId": "career[0][yourWishtoAchieveThroughSICProgram]",
             "required": true,
             "name": "career[0][yourWishtoAchieveThroughSICProgram]",
             "label": "Explain what you would like to achieve through SIC?",
             "type": "multiSelect",
             "disabled": false,
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "Participate in courses and access all materials free of charge",
                 "value": "Participate in courses and access all materials free of charge"
               },
               {
                 "label": "Experience machine learning tools and real-world problem solving with exciting curriculum",
                 "value": "Experience machine learning tools and real-world problem solving with exciting curriculum"
               },
               {
                 "label": "Grasp the landscape of data science tools and their applications",
                 "value": "Grasp the landscape of data science tools and their applications"
               },
               {
                 "label": "Opportunity to meet Samsung employees, industry leaders and field experts",
                 "value": "Opportunity to meet Samsung employees, industry leaders and field experts"
               }
             ]
           },
           {
             "fieldId": "career[0][hearAboutSIC]",
             "required": true,
             "name": "career[0][hearAboutSIC]",
             "label": "How did you find out about SIC?",
             "type": "select",
             "validations": {
               "required": "This field is required"
             },
             "options": [
               {
                 "label": "Social Media",
                 "value": "Social Media"
               },
               {
                 "label": "Referral",
                 "value": "Referral"
               },
               {
                 "label": "School/University",
                 "value": "School/University"
               },
               {
                 "label": "Event/Conference",
                 "value": "Event/Conference"
               },
               {
                 "label": "Online Advertisement",
                 "value": "Online Advertisement"
               },
               {
                 "label": "Samsung Website",
                 "value": "Samsung Website"
               },
               {
                 "label": "Word of Mouth",
                 "value": "Word of Mouth"
               },
               {
                 "label": "Career Fair",
                 "value": "Career Fair"
               },
               {
                 "label": "ESSCI Website",
                 "value": "ESSCI Website"
               },
               {
                 "label": "Alumni",
                 "value": "Alumni"
               }
             ]
           }
         ]
       }
     ]
   },
   {
     "stepId": "Upload Documents",
     "stepName": "Photo & Document Upload",
     "showStepName": false,
     "stepVisible": true,
     "stepPosition": 1,
     "stepType": "documentUpload",
     "sections": []
   },
   {
     "stepId": "summaryWithDeclaration",
     "stepName": "Summary and Declaration",
     "stepPosition": 5,
     "showStepName": true,
     "stepVisible": true,
     "stepType": "summary",
     "voucher": true,
     "sections": []
   }
];
